import React from "react";
import { Link, useLocation } from "react-router-dom";
import GroupActivityButton from "./GroupActivityButton";
import { AiOutlinePlusCircle, AiOutlineRightCircle } from "react-icons/ai";
import Loader from "../../../commonComponent/Loader";

function GroupActivitiesCard({
  isLoading,
  heading,
  paragarph,
  backColor,
  childeren,
}) {
  const location = useLocation();
  const state = location.state;

  return (
    <div className="col-md-4">
      <div
        className="gact_topcard position-relative "
        style={{ background: backColor }}
      >
        {isLoading && (
          <Loader
            visible={true}
            noMargin={true}
            mainStyle={{ height: "100%" }}
            style={{height:'1.7rem', width:'1.7rem'}}
          />
        )}
        {!isLoading && (
          <>
            {" "}
            <div
              className="text-end position-absolute"
              style={{ right: "10px", bottom: "15px" }}
            >
              {!(heading > 0)
                ? paragarph === "member" && (
                    <div
                      className="pointer text-decoration-none text-white"
                      data-bs-toggle="modal"
                      data-bs-target="#addmembermodal1"
                    >
                      <GroupActivityButton
                        className="py-1 btn"
                        color="white"
                        border="none"
                      >
                        <AiOutlinePlusCircle
                          size={"35px"}
                          className="text-white"
                        />{" "}
                      </GroupActivityButton>
                    </div>
                  )
                : paragarph === "member" && (
                    <Link
                      className="pointer text-decoration-none text-white"
                      to="/members"
                      state={{ user: state.selectedGroup }}
                    >
                      <GroupActivityButton
                        className="py-1 btn"
                        color="white"
                        border="none"
                      >
                        <AiOutlineRightCircle size={"35px"} />
                      </GroupActivityButton>
                    </Link>
                  )}
            </div>
            <div className="d-flex justify-content-between mt-3 ">
              <h4 className=" headFont ">
                {heading && !isNaN(heading) ? heading : "-"}{" "}
                {!isNaN(heading) ? childeren : null}
              </h4>
            </div>{" "}
          </>
        )}

        <p className="mt-3">{paragarph}</p>
      </div>
    </div>
  );
}

export default GroupActivitiesCard;
